import { handleRetrieveAllSpecialists } from "../../../../redux/public-slices/questionare.slice";
import { showDialog, showDialogWithData } from "../../../../redux/guest-slices/other.slice";
import TablePagination from "../../../../components/common/TablePagination";
import { checkUserType, FILE_PATH_URI } from "../../../../utils/helper";
import { useChatInitiate } from "../../../../hooks/useChatInitiate";
import { APPOINTMENT_SLOTS, FEATURE_GUARD, GUEST_LOGIN } from "../../../../utils/keywords";
import Availability from "../../../../components/ui/availability";
import { useDispatch, useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import Images from "../../Home/temp-data/Images";
import Icons from "../../../../assets/js/Icons";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { useExchangeRate } from "../../../../hooks/useExchangeRate";

import {
	Alert, Box, Button, Card, CardContent, Container, Grid2 as Grid,
	Skeleton, Stack, Typography, Avatar, Chip, IconButton, Tooltip,
} from "@mui/material";

function SpecialistDetails() {
	const dispatch = useDispatch();
	const checkUser = checkUserType();
	const { loadings } = useSelector((state) => state.otherSlice);
	const { initiateGeneralChat } = useChatInitiate();
	const [data, setData] = useState([]);
	const { format: formatLocalPrice } = useExchangeRate();

	const questionnaire = useSelector((state) => state.authSlice.questionnaire);

	const { subscription, plan, features } = useSelector(
		(state) => state.subscriptionSlice
	);

	const isSubscribed = Boolean(
		subscription?.hasSubscription ||
		(plan?.name && plan?.name !== "basic") ||
		features?.includes("CHAT_ACCESS_LIMITED") ||
		features?.includes("CHAT_ACCESS_UNLIMITED")
	);

	const hasAccess = features?.includes(
		"APPOINTMENT_UNLIMITED"
	);

	useEffect(() => {
		handleRetrieve();
		// eslint-disable-next-line
	}, []);

	const handleRetrieve = async (filters) => {
		const specIds = [];

		if (questionnaire) {
			if (questionnaire.areaToImprove)
				specIds.push(questionnaire.areaToImprove);
			if (questionnaire.prioritySupportFactor)
				specIds.push(questionnaire.prioritySupportFactor);

			Object.keys(questionnaire).forEach((key) => {
				if (key.startsWith("reasonForVisit") && questionnaire[key]) {
					specIds.push(questionnaire[key]);
				}
			});
		}
		const payload = {
			limit: 10,
			currentPage: filters?.currentPage || null,
			country: questionnaire?.country,
			preferredConnectTime: questionnaire?.preferredConnectTime,
			preferredLanguage: questionnaire?.preferredLanguage,
			timezone: questionnaire?.timezone,
			specializationIds: [...new Set(specIds)],
		};

		const response = await dispatch(
			handleRetrieveAllSpecialists(payload)
		).unwrap();
		setData(response || []);
	};

	const handleLogin = () => {
		dispatch(showDialog(GUEST_LOGIN));
	};
	const handleChatInitiate = async (receiver) => {
		if (!checkUser) {
			handleLogin();
			return;
		}
		initiateGeneralChat(receiver);

	};
	const openFollowUpModal = (item) => {

		if (!hasAccess) {
			dispatch(
				showDialog(FEATURE_GUARD, {
					title: "Appointment Booking Locked",
					description:
						"Upgrade to Premium or Platinum to book appointments with specialists.",
					requiredPlan: "Premium",
				})
			);

			return;
		}

		if (!checkUser) {
			handleLogin();
		} else {
			dispatch(
				showDialogWithData({
					type: APPOINTMENT_SLOTS,
					data: {
						specialistId: item?._id,
					},
				})
			)
		}
	}





	return (
		<Fragment>
			{/* banner */}
			<Box
				component="section"
				sx={{
					bgcolor: "dark.main",
					backgroundSize: "cover",
					backgroundImage: `url("${Images?.forumImg5}")`,
					backgroundPosition: { xs: "top left", md: "center" },
				}}
			>
				<Box
					sx={{
						bgcolor: "#00000085",
						py: { xs: 12, lg: 15 },
					}}
				>
					<Container maxWidth={false} fixed>
						<Box
							sx={{
								gap: 2.5,
								height: "100%",
								display: "flex",
								alignItems: "center",
								flexDirection: "column",
								justifyContent: "center",
							}}
						>
							<Typography
								component="h2"
								sx={{
									color: "white",
									fontWeight: "700",
									textShadow: "4px 4px 4px #00000073",
									textAlign: { xs: "center", md: "start" },
									fontSize: { xs: "25px", md: "32px", lg: "45px", xxl: "54px" },
								}}
							>Here's Your Personalized Wellness Match
							</Typography>
						</Box>
					</Container>
				</Box>
			</Box>

			<Box sx={{ py: { xs: 5, lg: 10 }, bgcolor: "#f1f1f1" }}>
				<Container maxWidth={false} fixed>
					<Box sx={{ mb: 4, maxWidth: { xs: '100%', md: '70%', lg: '70%' }, mx: 'auto' }}>

						{loadings?.retrieveAll ? (
							new Array(6).fill().map((_, i) => (
								<Grid key={i} size={12}>
									<Skeleton
										variant="rectangular"
										sx={{
											width: '100%',
											height: 280,
											borderRadius: 1,
										}}
									/>
								</Grid>
							))
						) : data?.records?.length === 0 ? (
							<Grid size={12}>
								<Alert color="error" severity="error">
									No Specialists Found!
								</Alert>
							</Grid>
						) : (
							data?.records?.map((specialist) => (<Fragment key={specialist?._id}>
								<Card
									sx={{
										bgcolor: '#FAF7F5',
										boxShadow: 'none',
										border: 'none',
										mb: 4,
										borderRadius: "8px"
									}}
								>
									<CardContent sx={{ p: 4 }}>
										<Stack direction={{ xs: "column", lg: "row" }} spacing={3} alignItems={{ xs: "center", sm: "center", lg: "flex-start" }}
										>
											<Box>

												<Box
													component={NavLink}

													to={`/specialist/${specialist?._id}`}
													sx={{
														position: "relative",
														overflow: "hidden",
														mb: 4,
														justifyContent: "center",
														display: "flex",
													}}
												>
													<Avatar
														variant="rounded"
														src={
															specialist?.profilePhoto
																? FILE_PATH_URI + specialist?.profilePhoto
																: ""
														}

														sx={{
															width: 220,
															height: 220,
															borderRadius: 3,
														}}
													/>

													<IconButton

														sx={{
															position: "absolute",
															bottom: -20,
															right: -20,
															width: 76,
															height: 76,
															overflow: "hidden",
															zIndex: 1,
															borderRadius: "50%",
															display: "flex",
															alignItems: "center",
															bgcolor: "#E9F0F8",
															border: "6px solid #ffffffff",
															justifyContent: "center",
															"&:hover": {
																bgcolor: "#DCE9F6",
																transform: "scale(1.08)",
																boxShadow: "0 8px 18px rgba(0,0,0,0.18)",
															},
														}}
													>
														<Icons.ArrowRightUp />
													</IconButton>
												</Box>

												<Box sx={{
													textAlign: { xs: "center", md: "center", lg: "left" },
												}} >


													<Typography
														textTransform={"capitalize"}
														variant="h5"
														sx={{
															fontWeight: 600,
															mb: 0.5,
															color: '#2C2C2C'
														}}
													>
														{specialist?.name}
													</Typography>


													{specialist?.specializationNames?.map((name, i) => (
														<Typography
															key={i}
															sx={{ mb: 0.5 }}
														>
															{name}
														</Typography>
													))}

												</Box>
											</Box>

											<Box sx={{
												flex: 1,
												display: "flex",
												gap: 1,
												flexDirection: "column",
												justifyContent: { xs: "center", lg: "space-between" },
												alignItems: { xs: "center", lg: "flex-start" },
											}}>
												<Box sx={{ width: "100%", display: "flex", alignItems: "center" }}>
													<Typography
														textTransform={"capitalize"}
														variant="h5"
														sx={{
															fontWeight: 600,
															color: '#2C2C2C'
														}}
													>
														DEALS IN
													</Typography>

													<Box ml="auto">
														{(moment
															.tz(
																specialist?.availability?.schedule?.[String(moment().format("dddd")).toLowerCase()]?.startTime,
																"HH:mm",
																specialist?.availability?.timeZone
															)
															.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
															.format("HH:mm") <= moment().format("HH:mm") &&
															moment
																.tz(
																	specialist?.availability?.schedule?.[String(moment().format("dddd")).toLowerCase()]?.endTime,
																	"HH:mm",
																	specialist?.availability?.timeZone
																)
																.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
																.format("HH:mm") >= moment().format("HH:mm")
														) &&
															<Chip
																size="small"
																color="success"
																label="Online now"
																variant="outlined"
																sx={{ borderRadius: 1.5, fontWeight: "500" }}
															/>
														}
													</Box>
												</Box>

												<Stack
													direction="row"
													justifyContent={{ sm: "center", lg: "flex-start" }}
													flexWrap="wrap"
													gap={1}
												>
													{specialist?.areaNames?.map((spec, i) => (
														<Chip
															key={i}
															label={spec}
															size="small"
															sx={{
																alignItems: "flex-start",
																height: "auto",
																py: 1,

																"& .MuiChip-label": {
																	whiteSpace: "normal",
																	display: "block",
																},

																bgcolor: "#AFCBE547",
															}}
														/>
													))}
												</Stack>

												{specialist?.pricing?.startingPrice != null && (
													<Chip
														label={`Starts at ${formatLocalPrice(specialist.pricing.startingPrice, specialist?.pricing?.currency)}`}
														size="small"
														sx={{
															bgcolor: "#eef6ea",
															color: "#2e7d32",
															fontWeight: 600,
														}}
													/>
												)}


												<Typography
													variant="body2"
													fontWeight={500}
													color="other.color"
													pb={1}
												>
													{specialist?.experience} years offering treatment
												</Typography>

												<Typography
													variant="body2"
													color="other.color1"
													textAlign={"justify"}
												>
													{specialist?.professionalBio}
												</Typography>



												<Box sx={{
													mt: "auto",
													display: "flex",
													gap: 2,
													flexDirection: { xs: "column", sm: "row" },
													pt: 2
												}}>
													{specialist?.schedule && (
														<Button
															variant="contained"
															color="secondary"
															onClick={() => openFollowUpModal(specialist)}
															sx={{ borderRadius: "30px", px: 2.5, py: 1.5, color: "white" }}
														>
															Book Appointment
														</Button>
													)}
													{(() => {
														const isOnline = Boolean(
															moment
																.tz(
																	specialist?.availability?.schedule?.[String(moment().format("dddd")).toLowerCase()]?.startTime,
																	"HH:mm",
																	specialist?.availability?.timeZone
																)
																.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
																.format("HH:mm") <= moment().format("HH:mm") &&
															moment
																.tz(
																	specialist?.availability?.schedule?.[String(moment().format("dddd")).toLowerCase()]?.endTime,
																	"HH:mm",
																	specialist?.availability?.timeZone
																)
																.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
																.format("HH:mm") >= moment().format("HH:mm")
														);

														return (
															<Tooltip title={!isSubscribed ? "Subscription plan required to chat with specialists" : !isOnline ? "Specialist is currently offline" : ""}>
																<span>
																	<Button
																		color="success"
																		variant="contained"
																		startIcon={<Icons.ChatStrokeRounded />}
																		onClick={() => handleChatInitiate(specialist?._id)}
																		sx={{ borderRadius: "100px", color: "white", py: 1.5 }}
																		disabled={!isOnline}
																	>
																		Chat
																	</Button>
																</span>
															</Tooltip>
														);
													})()}

													<Availability
														trigger={
															<Button
																color="dark"
																size="large"
																variant="contained"
																startIcon={<Icons.Alert />}
																sx={{ borderRadius: "100px", color: "white", py: 1.5 }}
															>Chat avaliablity
															</Button>
														}
														availability={specialist?.availability}
													/>
												</Box>
											</Box>
										</Stack>
									</CardContent>
								</Card>


							</Fragment>

							))
						)}
					</Box>
					<TablePagination
						pagination={data?.pagination}
						length={data?.records?.length}
						loading={loadings?.retrieveAll}
						cb={handleRetrieve}
					/>
				</Container>
			</Box>
		</Fragment>
	);
}

export default SpecialistDetails;
